export const EVENTO_NAV_SECTIONS = [
  {
    key: "generalidades",
    label: "Generalidades",
    icon: "bi-grid-3x3-gap",
    children: null,
  },
  {
    key: "informacion_historica",
    label: "Información histórica",
    icon: "bi-file-earmark-text",
    children: [
      {
        key: "documentos",
        label: "Documentos históricos",
        icon: "bi-folder2-open",
      },
      {
        key: "arbol_fuentes",
        label: "Árbol de fuentes",
        icon: "bi-diagram-3",
      },
      { key: "efectos", label: "Efectos", icon: "bi-lightning-charge" },
    ],
  },
  {
    key: "datos_geologicos",
    label: "Información geológica",
    icon: "bi-layers",
    children: [
      {
        key: "parametros",
        label: "Parámetros eruptivos",
        icon: "bi-graph-up-arrow",
      },
      {
        key: "fenomenos",
        label: "Fenómenos asociados",
        icon: "bi-activity",
      },
      {
        key: "referencias",
        label: "Referencias especializadas",
        icon: "bi-journal-bookmark",
      },
    ],
  },
  {
    key: "multimedia",
    label: "Multimedia",
    icon: "bi-play-btn",
    children: [
      { key: "imagenes", label: "Imágenes", icon: "bi-image" },
      { key: "videos", label: "Videos", icon: "bi-camera-video" },
      { key: "infografias", label: "Infografías", icon: "bi-easel" },
      { key: "mapas", label: "Mapas", icon: "bi-map" },
    ],
  },
];

export const EVENTO_TIPO_LINEA_LABEL = {
  desastre: "Evento destacado",
  actividad: "Actividad",
  descripcion: "Descripción histórica",
  otros_eventos_geologicos: "Otros eventos geológicos",
};

export const EVENTO_TIPO_COLORS = {
  desastre: "#390302",
  actividad: "#DD6E1C",
  descripcion: "#FEB912",
  otros_eventos_geologicos: "#C8C8C8",
};

export function eventoTipoBadgeTextColor(tipo) {
  return tipo === "desastre" || tipo === "actividad" ? "#ffffff" : "#1a1a1a";
}

/** Mensaje vacío: "No hay {sección} para mostrar" */
export function evtEmptyMessage(seccion) {
  return `No hay ${seccion} para mostrar`;
}

export const EVENTO_EMPTY_MESSAGES = {
  resumen: evtEmptyMessage("resumen"),
  documentos: evtEmptyMessage("documentos históricos"),
  arbol_fuentes: evtEmptyMessage("árbol de fuentes"),
  efectos: evtEmptyMessage("efectos"),
  parametros: evtEmptyMessage("parámetros eruptivos"),
  fenomenos: evtEmptyMessage("fenómenos asociados"),
  referencias: evtEmptyMessage("referencias especializadas"),
  imagenes: evtEmptyMessage("imágenes"),
  videos: evtEmptyMessage("videos"),
  infografias: evtEmptyMessage("infografías"),
  mapas: evtEmptyMessage("mapas"),
};
